// Soccer, Rugby, Futsal
const soccer = [
  { providerId: 'HT' },
  { providerId: 'FT' },
  { providerId: 'OT' },
  { providerId: 'AP' },
];

// Basketball, American Football
const basketball = [
  { providerId: '1Q' },
  { providerId: '2Q' },
  { providerId: '3Q' },
  { providerId: '4Q' },
  { providerId: 'FT' },
  { providerId: 'OT' },
];

// Baseball, Motorsport, Cricket, Bowls
const baseball = [
  { providerId: 'FT' },
];


// Ice hockey, Floorball
const iceHockey = [
  { providerId: '1P' },
  { providerId: '2P' },
  { providerId: '3P' },
  { providerId: 'FT' },
  { providerId: 'OT' },
  { providerId: 'AP' },
];

const resultsMap = {
  1: soccer,
  2: basketball,
  3: baseball,
  4: iceHockey,
  5: [
    { providerId: 'Set1' },
    { providerId: 'Set2' },
    { providerId: 'Set3' },
    { providerId: 'Set4' },
    { providerId: 'Set5' },
    { providerId: 'FT' },
  ],
  6: [
    { providerId: 'HT' },
    { providerId: 'FT' },
    { providerId: 'OT' },
  ],
  7: iceHockey,
  10: baseball,
  11: baseball,
  12: soccer,
  15: [
    { providerId: 'HT' },
    { providerId: 'FT' },
  ],
  16: basketball,
  21: baseball,
  23: [
    { providerId: 'Set1' },
    { providerId: 'Set2' },
    { providerId: 'Set3' },
    { providerId: 'Set4' },
    { providerId: 'Set5' },
    { providerId: 'FT' },
  ],
  26: [
    { providerId: '1Q' },
    { providerId: '2Q' },
    { providerId: '3Q' },
    { providerId: '4Q' },
    { providerId: 'FT' },
    { providerId: 'OT' },
    { providerId: 'AP' },
  ],
  29: soccer,
  31: [
    { providerId: 'Set1' },
    { providerId: 'Set2' },
    { providerId: 'Set3' },
    { providerId: 'FT' },
  ],
  32: baseball,
  default: baseball,
};

export default resultsMap;
